<aside class="w-100 p-2">
  <!--  new style logo on our brands-->
  <div class="logo-and-nav-in-sidebar mb-2" *ngIf="!isRival">
    <a class="navbar-brand text-center" routerLink=""><img src="{{assetsSource}}/{{logoFileNameForAILogo ?? logoFileName}}" [alt]="logoAltText"></a>
  </div>

<!--  balance and cashier on mobile for logged in user -->
  <div *ngIf="user" class="p-2 pb-0 d-flex justify-content-center d-sm-none mb-2 flex-grow-1 mt-2 row gx-2">
    <div class="col">
      <button class="btn btn-outline-primary w-100" disabled><span class="fw-bold">{{ balance | currency: user.currency }}</span></button>
    </div>
    <div class="col">
      <button class="btn btn-primary w-100" type="button" (click)="goToCashier(); decideTogglingSidebar()">{{ "ACCOUNT.BTN_TO_CASHIER" | translate }} </button>
    </div>
  </div>

  <!--for user / recommended section-->
  <div class="mb-2 p-2 py-0 rounded-2 bg-main" *ngIf="user">
    <div class="navbar">
      <ul class="navbar-nav">

        <li class="nav-item"><a class="nav-link d-flex align-items-center" routerLink="games/favourites" routerLinkActive="active-link" (click)="decideTogglingSidebar()">
          <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="'favourites'"></app-svg-icon>
          <span class="fw-bold">{{ 'CATEGORIES.FAVOURITES' | translate }}</span>
        </a></li>

        <li class="nav-item"><a class="nav-link d-flex align-items-center" routerLink="games/recent" routerLinkActive="active-link" (click)="decideTogglingSidebar()">
          <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="'recent'"></app-svg-icon>
          <span class="fw-bold">{{ 'CATEGORIES.RECENT' | translate }}</span>
        </a></li>

        <li class="nav-item"><a class="nav-link d-flex align-items-center" routerLink="games/recommended" routerLinkActive="active-link" (click)="decideTogglingSidebar()">
          <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="'trynext'"></app-svg-icon>
          <span class="fw-bold">{{ 'CATEGORIES.RECOMMENDED2' | translate }}</span>
        </a></li>

      </ul>
    </div>
  </div>


<!--  language dropdown for non-logged in user -->
  <div class="mb-2 p-2 py-0 rounded-2 bg-main" *ngIf="!user">
    <div class="navbar d-block">
      <ul class="navbar-nav">
        <li class="nav-item dropend">
          <button class="nav-link dropdown-toggle d-flex align-items-center" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="'languages'"></app-svg-icon>
            <span class="fw-bold">{{ 'LANG' | translate }}</span>
          </button>

          <ul class="dropdown-menu dropdown-menu-end dropdown-menu-dark dropdown-bg border-0">
            <li *ngFor="let option of languageOptions" (click)="switchLang(option.value)">
              <button class="dropdown-item" type="button">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <img class="me-2" [ngSrc]="'assets/lang_images/' + option.value + '.svg'" width="20"
                         [height]="option.height" [alt]="option.label">
                    <label class="fw-bold form-check-label">{{ option.label }}</label>
                  </div>
                  <input class="form-check-input mt-0" type="radio" name="lang" id="lang{{ option.value | titlecase }}"
                         [checked]="selectedLang === option.value">
                </div>
              </button>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>

  <!--  for user: profile/account section  -->
  <div class="mt-2 p-2 pb-0 rounded-2 bg-main" *ngIf="user">

    <h6 class="fw-bold mb-0">{{ 'ACCOUNT.TITLE' | translate }}</h6>
    <div class="navbar pt-0">
      <ul class="navbar-nav">

        <li class="nav-item"><a class="nav-link d-flex align-items-center" routerLink="account/cashier" routerLinkActive="active-link" (click)="decideTogglingSidebar()">
          <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="'cashier'"></app-svg-icon>
          <span class="fw-bold">{{ 'ACCOUNT.CASHIER' | translate }}</span>
        </a></li>

        <li class="nav-item"><a class="nav-link d-flex align-items-center" routerLink="account/promotions" routerLinkActive="active-link" (click)="decideTogglingSidebar()">
          <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="'mypromotions'"></app-svg-icon>
          <span class="fw-bold">{{ 'ACCOUNT.PROMO.TITLE' | translate }}</span>
        </a></li>

        <li class="nav-item"><a class="nav-link d-flex align-items-center" routerLink="account/profile" routerLinkActive="active-link" (click)="decideTogglingSidebar()">
          <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="'profile'"></app-svg-icon>
          <span class="fw-bold">{{ 'ACCOUNT.INFO.TITLE' | translate }}</span>
        </a></li>

<!--   <li class="nav-item"><a class="nav-link d-flex align-items-center" routerLink="account/jackpots" routerLinkActive="active-link"  (click)="decideTogglingSidebar()">-->
<!--   <app-svg-icon [pathIdentifier]="'jackpots'" class="variable-svg-icon me-2"></app-svg-icon>-->
<!--   <span class="fw-bold"> {{ 'ACCOUNT.JACKPOT.TITLE' | translate}}</span>-->
<!-- </a></li>-->

        <li class="nav-item"><a class="nav-link d-flex align-items-center clickable-link" (click)="decideTogglingSidebar(); openLogoutModal()">
          <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="'logout'"></app-svg-icon>
          <span class="fw-bold"> {{ 'LOGOUT.TITLE' | translate }} </span>
        </a></li>


      </ul>
    </div>
  </div>

<!--  Games section-->
  <div class="p-2 pb-0 rounded-2 bg-main" [ngClass]="{'mt-2': user}">
    <h6 class="fw-bold mb-0">{{ 'CATEGORIES.TITLE' | translate }}</h6>
    <div class="navbar pt-0">
      <ul class="navbar-nav">
        <li class="nav-item" *ngFor="let category of categories; let i = index">
<!--          [class.active-link]="i === 0 && router.url.includes('/details')" TODO why was this here??
             routerLink="/games/{{category.replace(' ', '')}}" -->
          <a class="nav-link d-flex align-items-center"
             routerLink="{{ category === 'all' ? '' : ('/games/'+ category)}}"
             routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}"
             (click)="decideTogglingSidebar()">
            <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="category"></app-svg-icon>
            <span class="fw-bold">{{ "CATEGORIES." + (category.replace('-','') | uppercase) | translate }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>

<!--  Providers section -->
  <div class="mt-2 p-2 rounded-2 bg-main">
    <a class="fs-6 fw-bold nav-link d-flex align-items-center" routerLink="providers" routerLinkActive="active-link"
       (click)="decideTogglingSidebar()">
      <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="'providers'"></app-svg-icon>
      <span class="fw-bold">{{ 'PROVIDERS.TITLE' | translate }}</span>
    </a>
  </div>


<!--  Promotions -->
  <div class="mt-2 p-2 rounded-2 bg-main" *ngIf="!user">
    <a class="fs-6 fw-bold nav-link d-flex align-items-center" routerLink="/promotions" routerLinkActive="active-link"
       (click)="decideTogglingSidebar()">
      <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="'promotions'"></app-svg-icon>
      <span class="fw-bold">{{ 'PROMOTIONS.TITLE' | translate }}</span>
    </a>
  </div>

<!--      <div class="mt-2 p-2 rounded-2 bg-main">-->
<!--        <a class="fs-6 fw-bold nav-link d-flex align-items-center" routerLink="leaderboard"  routerLinkActive="active-link"  (click)="decideTogglingSidebar()">-->
<!--          <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="'leaderboard'"></app-svg-icon>-->
<!--          <span class="fw-bold">{{'LEADERBOARD.TITLE' | translate}}</span>-->
<!--        </a>-->
<!--      </div>-->

<!--  Legal and Support section-->
  <div class="mt-2 p-2 py-0 rounded-2 bg-main">
    <div class="navbar d-block">
      <ul class="navbar-nav">
        <li class="nav-item"><a class="nav-link d-flex align-items-center" routerLink="info/about" (click)="decideTogglingSidebar()" [class.active-link]="router.url.includes('/info/') && !router.url.includes('/support') && !router.url.includes('/terms')">
          <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="'aboutus'"></app-svg-icon>
          <span class="fw-bold">{{ 'LEGAL.ABOUT.TITLE' | translate }}</span>
        </a></li>

        <li class="nav-item"><a class="nav-link d-flex align-items-center" routerLink="info/terms" (click)="decideTogglingSidebar()" routerLinkActive="active-link">
          <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="'terms'"></app-svg-icon>
          <span class="fw-bold">{{ 'LEGAL.TERMS.TITLE' | translate }}</span>
        </a></li>

        <li class="nav-item"><a class="nav-link d-flex align-items-center" routerLink="info/support" (click)="decideTogglingSidebar()" routerLinkActive="active-link">
          <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="'support'"></app-svg-icon>
          <span class="fw-bold">{{ 'LEGAL.SUPPORT.TITLE' | translate }}</span>
        </a></li>

        <li class="nav-item">
          <button class="btn btn-link nav-link d-flex align-items-center" (click)="decideTogglingSidebar(); openChat()">
            <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="'chat'"></app-svg-icon>
            <span class="fw-bold">{{ 'CHAT.TITLE' | translate }}</span>
          </button>
        </li>

        <!--  language dropdown for logged in user -->
        <li class="nav-item dropend" *ngIf="user">
          <button class="nav-link dropdown-toggle d-flex align-items-center" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="'languages'"></app-svg-icon>
            <span class="fw-bold">{{ 'LANG' | translate }}</span>
          </button>

          <ul class="dropdown-menu dropdown-menu-end dropdown-menu-dark dropdown-bg border-0">
                  <li *ngFor="let option of languageOptions" (click)="switchLang(option.value)">
                    <button class="dropdown-item" type="button">
                      <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                          <img class="me-2" [ngSrc]="'assets/lang_images/' + option.value + '.svg'" width="20"
                               [height]="option.height" [alt]="option.label">
                          <label class="fw-bold form-check-label">{{ option.label }}</label>
                        </div>
                        <input class="form-check-input mt-0" type="radio" name="lang" id="lang{{ option.value | titlecase }}"
                               [checked]="selectedLang === option.value">
                      </div>
                    </button>
                  </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>

  <div class="logo-and-nav-in-sidebar mb-2" *ngIf="!isRival">
    <div class="close-btn">
      <button class="navbar-toggler mt-2" type="button" (click)="toggleSidebar()" aria-label="Toggle navigation">
        <app-svg-icon class="variable-svg-icon me-2 d-block" [pathIdentifier]="'arrow_back'"></app-svg-icon>
      </button>
    </div>
  </div>


</aside>
